import { useState } from 'react';
import {
  Modal,
  ModalContent,
  ModalHeader,
  ModalBody,
  Table,
  TableHeader,
  TableColumn,
  TableBody,
  TableRow,
  TableCell,
  Button
} from '@heroui/react';

import { useGetUserInfo } from '../hooks/useGetUserInfo';

const UserInfo = ({userid, dismissModal, myUser}) => {
  const [info, setInfo] = useState();
  const [user, updateUser] = useGetUserInfo(userid);

  const revokeUnlimited = async () => {
    const limit = await fetch(`/api/v1/users/${userid}/revoke_unlimited`, {method: 'PUT'});
    const d = await limit.json();
    updateUser(d['user']);
    setInfo('Revoked unlimited flag');
  };

  const markUnlimited = async () => {
    const limit = await fetch(`/api/v1/users/${userid}/grant_unlimited`, {method: 'PUT'});
    const d = await limit.json();
    updateUser(d['user']);
    setInfo('User set for unlimited campaigns');
  };

  return (
    <Modal isOpen={true} isDismissable={true} onClose={dismissModal}>
      <ModalContent>
        <ModalHeader className='flex flex-col gap-1'>
          <img alt='' src={user?.avatar} style={{borderRadius: '12px', marginBottom: '15px'}} /> User {user?.email}
        </ModalHeader>
        <ModalBody>
          { info && <span style={{color: '#209020'}}>{info}</span> }
          <Table hideHeader area-label='User' color='danger' shadow='md'>
            <TableHeader style={{height: '0px'}}> columns={2}>
              <TableColumn style={{width: '200px'}}> </TableColumn>
              <TableColumn style={{width: '200px'}}> </TableColumn>
            </TableHeader>
            <TableBody>
              <TableRow>
                <TableCell>Status</TableCell>
                <TableCell>{user?.admin ? "Admin" : user?.super_unlimited ? "Unlimited" : "Standard"}</TableCell>
              </TableRow>
              <TableRow>
                <TableCell>Last Active</TableCell>
                <TableCell>{new Date(user?.last_active).toDateString().split(' ').slice(1, 4).join(' ')}</TableCell>
              </TableRow>
              <TableRow>
                <TableCell>Joined</TableCell>
                <TableCell>{new Date(user?.created_at).toDateString().split(' ').slice(1, 4).join(' ')}</TableCell>
              </TableRow>
              <TableRow>
                <TableCell>Campaigns</TableCell>
                <TableCell>{user?.campaign_count}</TableCell>
              </TableRow>
              <TableRow>
                <TableCell>Emails Generated</TableCell>
                <TableCell>{user?.email_record_count}</TableCell>
              </TableRow>
              <TableRow>
                <TableCell>Clicks Generated</TableCell>
                <TableCell>{user?.usage_count}</TableCell>
              </TableRow>
              <TableRow>
                <TableCell>User Type</TableCell>
                <TableCell>{user ? (user.provider || "Email") : "-"}</TableCell>
              </TableRow>
            </TableBody>
          </Table>
          { myUser?.admin &&
            <Button color={user?.super_unlimited ? 'warning' : 'success'}
                  onPress={() => user?.super_unlimited ? revokeUnlimited() : markUnlimited()}
                  style={{marginTop: '10px', marginBottom: '10px'}}>
              {user?.super_unlimited ? 'Revoke' : 'Grant'} Unlimited
            </Button>
          }
        </ModalBody>
      </ModalContent>
    </Modal>
  );
}

export default UserInfo;
